import { GtagHandler } from '../../../app'

export default {
    props: {
        action: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: null
        },
        intro: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        submitLabel: {
            type: String,
            default: null
        },
        feedback: {
            type: String,
            default: null
        },
        emailContent: {
            type: Object,
            default: {},
        }
    },
    data: () => ({
        email: '',
        // emailContent: [],
        hasFeedback: false,
    }),
    mounted() {
        console.log(this.emailContent)
    },
    methods: {
        submit() {

            const data = {
                'email': this.email,
                'data': this.emailContent
            };

            let isError = false;

            fetch(this.action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
            .then(response => {
                if (response.status !== 200 && response.status !== 202) {
                    isError = true
                }
                return response.json()
            })
            .then(response => {
                if (isError) {
                    this.hasErrors = true
                } else {
                    GtagHandler.emit('surveyDownload')

                    this.hasFeedback = true
                }
            })
        }
    },
    template: `
        <div class="c-survey_results_section">
            <div class="c-survey_results_section_header">
                <h2
                    v-if="title"
                    class="c-heading -h2"
                    v-html="title"
                ></h2>
            </div>
            <div class="c-survey_results_section_content">
                <div class="o-layout -gutter -top">
                    <div class="o-layout_item u-2/5@from-medium | u-margin-small-bottom">
                        <p
                            v-if="intro"
                            v-html="intro"
                        ></p>
                    </div>
                    <div class="o-layout_item u-3/5@from-medium">
                        <div
                            :class="{ 'has-feedback' : hasFeedback }"
                            class="c-mail-form_wrap"
                        >
                            <form ref="emailForm" class="c-mail-form" @submit.prevent="submit">
                                <input
                                    type="email"
                                    name="email"
                                    v-model="email"
                                    required
                                    class="c-mail-form_input"
                                    :placeholder="placeholder"
                                >
                                <input
                                    type="hidden"
                                    name="emailContent"
                                    v-model="emailContent"
                                >
                                <input
                                    type="submit"
                                    class="c-mail-form_submit"
                                    :value="submitLabel"
                                >
                                <p
                                    v-if="feedback"
                                    class="c-mail-form_feedback"
                                    v-html="feedback"
                                ></p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
}
